import React from 'react'
import { Box } from '@chakra-ui/react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { SettingsProvider } from './contexts/SettingsContext'
import ProtectedRoute from './components/ProtectedRoute'
import HomePage from './pages/HomePage'
import YouTubePage from './pages/YouTubePage'
import AdminPage from './pages/AdminPage'
import PromoPage from './pages/PromoPage'

const App = () => {
  return (
    <AuthProvider>
      <SettingsProvider>
        <Router>
          <Box minH="100vh">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/youtube" element={<YouTubePage />} />
              <Route path="/links" element={<PromoPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Box>
        </Router>
      </SettingsProvider>
    </AuthProvider>
  )
}

export default App
